export enum DonateRoutes
{
	Home = "/",
	Donate = "/donate",
	DonateSuccess = "/donate/success"
}